module.exports = __webpack_public_path__ + "assets/72173d031ee5c532f476a3c0c9132737.mp3";